import React from "react";
import { ShieldCheck, Zap, Users } from "lucide-react";

const Values = () => {
  const values = [
    {
      icon: ShieldCheck,
      title: "Quality",
      description: "Products built to perform, day in and day out. We don't sell landfill fillers."
    },
    {
      icon: Users,
      title: "Reliability",
      description: "You can count on us and our stock. 99.8% fill rate across all categories."
    },
    {
      icon: Zap,
      title: "Agility",
      description: "Fast-moving and always ready to respond. We pivot faster than the market."
    }
  ];

  return (
    <div className="bg-dreibach-black border-y border-white/5 py-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="heading-md text-white mb-4">Our Values</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            We build trust by delivering - every order, every category, every time.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-12">
          {values.map((val, idx) => (
            <div key={idx} className="flex flex-col items-center text-center group">
              <div className="w-16 h-16 bg-white/5 rounded-full flex items-center justify-center mb-6 group-hover:bg-dreibach-teal group-hover:text-white transition-all duration-300">
                <val.icon className="w-8 h-8 text-dreibach-teal group-hover:text-white" />
              </div>
              <h3 className="text-xl font-bold text-white uppercase tracking-wide mb-3">{val.title}</h3>
              <p className="text-gray-400 leading-relaxed max-w-sm">
                {val.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Values;
